<script>
	import { onMount, createEventDispatcher } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		cabecalhoPadraoRequisicao,
		API, TextoFeedback} from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let tipoGrupoSelecionado, nome, descricao, captchaUsuario;
	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let tiposGrupos = [];
	let informacosAPICache;
	
	onMount(async () => {
		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		let tg = informacosAPICache?.tipos_grupos_sistema ?? [];
		tiposGrupos = Object.entries(tg);
	});

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Salvando grupo ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('grupos'), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					tipo: tipoGrupoSelecionado, 
					nome: nome, 
					descricao: descricao
				})
			}).catch(erros => {
				console.log(erros);

				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.CREATED) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: 'Grupo cadastrado com sucesso.'
				});

				replace('/painel');
			} else if (resposta.status == StatusHttp.UNPROCESSABLE_ENTITY) {
				tituloAviso = 'Verifique os dados informados!'
				feedbackUsuario.push(json?.mensagem);
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}

	}
</script>

<TBox 
	titulo="Cadastro de Grupos" 
	subtitulo="Formulário de cadastro de grupos" 
	largura="8" 
	deslocamento="2" 
	icone="grupo">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column is-full">
				<small class="has-text-primary">Selecione o tipo do grupo:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={tipoGrupoSelecionado} name="tipo_grupo" required>
						<option value="">Selecione...</option>
						{#each tiposGrupos as [chave, valor]}
						<option value="{chave}">{chave}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column is-full">
				<small class="has-text-primary">Nome do grupo:</small>
				<div class="field">
					<input 
						bind:value={nome}
						name="nome" 
						type="text" 
						placeholder="Digite aqui..." 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<small class="has-text-primary">Descrição:</small>				
				<div class="field">
					<textarea 
						bind:value={descricao}
						class="textarea is-primary is-size-5" 
						placeholder="Detalhe aqui sobre o que se trata este grupo"
						name="descricao"
						required></textarea>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Cadastrar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>